var map = {
	"./api/searchAdapter": [
		"./core/lib/search/adapter/api/searchAdapter.ts",
		"vsf-search-adapter-0"
	],
	"./graphql/searchAdapter": [
		"./core/lib/search/adapter/graphql/searchAdapter.ts",
		"vsf-search-adapter-1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./core/lib/search/adapter lazy recursive ^\\.\\/.*\\/searchAdapter$";
module.exports = webpackAsyncContext;